/**
 * Venice Press — Product Page Conversion Enhancements  (v1)
 *
 * A. Trust Signal Strip — injected after payment buttons
 * B. Mobile Sticky ATC Bar — IntersectionObserver on main ATC
 * C. ATC Button State Feedback — loading spinner + success state
 * D. "or checkout with" separator — CSS handles it; JS fallback if needed
 *
 * Runs only on /products/ pages.
 * Vanilla JS, IIFE, defensive coding. No jQuery.
 */
(function () {
  'use strict';

  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) return;

  // Guard against double-init
  var VP_PDP_VERSION = 1;
  if (window.__vpPdpVersion && window.__vpPdpVersion >= VP_PDP_VERSION) return;
  window.__vpPdpVersion = VP_PDP_VERSION;

  /* ================================================================
     Helpers
     ================================================================ */

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return (ctx || document).querySelectorAll(sel);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ================================================================
     A. Trust Signal Strip
     ================================================================ */

  function initTrustStrip() {
    try {
      // Already injected?
      if (qs('.vp-trust-strip')) return;

      // Find the insertion point — after the payment buttons / buy buttons block
      var anchor =
        qs('.shopify-payment-button') ||
        qs('.accelerated-checkout-block') ||
        qs('.product-form-buttons') ||
        qs('.buy-buttons-block') ||
        qs('product-form');

      if (!anchor) return;

      // Walk up to find a good parent if needed
      var insertAfter = anchor;

      // SVG icons (inline, no external deps)
      var truckSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
      var shieldSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>';
      var leafSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66L7 18h0"></path><path d="M2 2s7.1 1.13 12.05 5.05C18.52 10.65 20 16 20 16s-5.35-1.48-8.95-5.95C7.13 5.1 2 2 2 2z"></path></svg>';

      var strip = document.createElement('div');
      strip.className = 'vp-trust-strip';
      strip.innerHTML =
        '<div class="vp-trust-item">' + truckSvg + '<span>Ships in 1\u20133 business days</span></div>' +
        '<div class="vp-trust-item">' + shieldSvg + '<span>Pressed fresh, just for you</span></div>' +
        '<div class="vp-trust-item">' + leafSvg + '<span>Premium cotton, pre-shrunk</span></div>';

      // Insert after the anchor element
      if (insertAfter.nextSibling) {
        insertAfter.parentNode.insertBefore(strip, insertAfter.nextSibling);
      } else {
        insertAfter.parentNode.appendChild(strip);
      }
    } catch (e) {
      // Silent fail — trust strip is non-critical
    }
  }

  /* ================================================================
     B. Mobile Sticky ATC Bar
     ================================================================ */

  function initMobileStickyATC() {
    try {
      // Already injected?
      if (qs('.vp-mobile-sticky-atc')) return;

      // Only on mobile/tablet viewports
      if (window.innerWidth >= 769) return;

      // Find the main ATC button
      var mainATCBtn =
        qs('.product-form-buttons .add-to-cart-button') ||
        qs('.buy-buttons-block .add-to-cart-button') ||
        qs('button.add-to-cart-button');

      if (!mainATCBtn) return;

      // Find the product form to trigger submit
      var mainForm =
        qs('product-form form') ||
        qs('.shopify-product-form form') ||
        qs('form[action*="/cart/add"]');

      // Get product title
      var titleEl = qs('.product-information h1') || qs('h1');
      var titleText = titleEl ? titleEl.textContent.trim() : 'Add to Cart';

      // Get price
      var priceEl = qs('.price');
      var priceText = priceEl ? priceEl.textContent.trim() : '';

      // Build the sticky bar
      var bar = document.createElement('div');
      bar.className = 'vp-mobile-sticky-atc';
      bar.innerHTML =
        '<div class="vp-mobile-sticky-atc__info">' +
          '<div class="vp-mobile-sticky-atc__title">' + titleText + '</div>' +
          '<div class="vp-mobile-sticky-atc__price">' + priceText + '</div>' +
        '</div>' +
        '<button type="button" class="vp-mobile-sticky-atc__btn">Add to Cart</button>';

      document.body.appendChild(bar);

      // Click handler — trigger the main form submit
      var stickyBtn = qs('.vp-mobile-sticky-atc__btn', bar);
      if (stickyBtn && mainForm) {
        stickyBtn.addEventListener('click', function () {
          // Try to find and click the real ATC button to trigger Shopify's JS
          var realBtn = mainForm.querySelector('[type="submit"]') || mainForm.querySelector('.add-to-cart-button');
          if (realBtn) {
            realBtn.click();
          } else {
            mainForm.submit();
          }
        });
      } else if (stickyBtn && mainATCBtn) {
        stickyBtn.addEventListener('click', function () {
          mainATCBtn.click();
        });
      }

      // IntersectionObserver — show/hide sticky bar based on main ATC visibility
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // Main ATC is visible — hide sticky bar
              bar.classList.remove('vp-visible');
            } else {
              // Main ATC scrolled out — show sticky bar
              bar.classList.add('vp-visible');
            }
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });

        observer.observe(mainATCBtn);
      }

      // Update price if variant changes (listen for Shopify variant change events)
      document.addEventListener('variant:changed', function (e) {
        try {
          if (e.detail && e.detail.variant && e.detail.variant.price) {
            var p = (e.detail.variant.price / 100).toFixed(2);
            var priceDisplay = qs('.vp-mobile-sticky-atc__price', bar);
            if (priceDisplay) priceDisplay.textContent = '$' + p;
          }
        } catch (ex) {}
      });

    } catch (e) {
      // Silent fail — sticky ATC is non-critical
    }
  }

  /* ================================================================
     C. ATC Button State Feedback
     ================================================================ */

  function initATCStateFeedback() {
    try {
      var form =
        qs('product-form form') ||
        qs('.shopify-product-form form') ||
        qs('form[action*="/cart/add"]');

      if (!form) return;

      var atcBtn =
        form.querySelector('.add-to-cart-button') ||
        form.querySelector('[type="submit"]');

      if (!atcBtn) return;

      // Store original text content element
      var textEl = atcBtn.querySelector('.add-to-cart-text__content') || atcBtn.querySelector('.add-to-cart-text');

      // Listen for form submit
      form.addEventListener('submit', function () {
        // Loading state
        atcBtn.classList.add('vp-loading');
        atcBtn.classList.remove('vp-success');

        // Horizon theme uses fetch for cart add, so we can't easily detect
        // the response. Use a timeout approach:
        // - 1.2s for loading spinner (typical AJAX cart add time)
        // - then success state for 2s
        // - then revert

        setTimeout(function () {
          atcBtn.classList.remove('vp-loading');
          atcBtn.classList.add('vp-success');

          // Change button text to show success
          if (textEl) {
            var origText = textEl.textContent;
            textEl.textContent = 'Added \u2713';

            setTimeout(function () {
              atcBtn.classList.remove('vp-success');
              textEl.textContent = origText;
            }, 2000);
          } else {
            setTimeout(function () {
              atcBtn.classList.remove('vp-success');
            }, 2000);
          }
        }, 1200);
      });

      // Also intercept fetch-based cart adds for more accurate timing
      if (window.fetch) {
        var origFetch = window.fetch;
        window.fetch = function () {
          var url = arguments[0];
          var isCartAdd = false;

          if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
            isCartAdd = true;
          } else if (url && typeof url === 'object' && url.url && url.url.indexOf('/cart/add') !== -1) {
            isCartAdd = true;
          }

          var result = origFetch.apply(this, arguments);

          if (isCartAdd) {
            result.then(function (response) {
              if (response.ok) {
                // Cart add succeeded — trigger success state immediately
                atcBtn.classList.remove('vp-loading');
                atcBtn.classList.add('vp-success');

                if (textEl) {
                  var origText2 = textEl.textContent;
                  if (origText2 !== 'Added \u2713') {
                    textEl.textContent = 'Added \u2713';
                    setTimeout(function () {
                      atcBtn.classList.remove('vp-success');
                      textEl.textContent = origText2;
                    }, 2000);
                  }
                } else {
                  setTimeout(function () {
                    atcBtn.classList.remove('vp-success');
                  }, 2000);
                }
              }
            }).catch(function () {
              atcBtn.classList.remove('vp-loading');
            });
          }

          return result;
        };
      }

    } catch (e) {
      // Silent fail
    }
  }

  /* ================================================================
     D. "or checkout with" separator — CSS ::before fallback
     If the Horizon theme wraps the payment button in a way that
     prevents the CSS ::before from rendering, inject via JS.
     ================================================================ */

  function initCheckoutSeparator() {
    try {
      var payBtn = qs('.shopify-payment-button');
      if (!payBtn) return;

      // Check if CSS ::before is already rendering
      var before = window.getComputedStyle(payBtn, '::before');
      var content = before.getPropertyValue('content');

      // If content is 'none' or empty, the CSS pseudo-element didn't work
      // Wait a bit for CSS to load, then check
      setTimeout(function () {
        var before2 = window.getComputedStyle(payBtn, '::before');
        var content2 = before2.getPropertyValue('content');

        if (!content2 || content2 === 'none' || content2 === '""' || content2 === "''") {
          // CSS ::before didn't render — inject separator via JS
          if (qs('.vp-checkout-separator')) return; // Already injected

          var sep = document.createElement('div');
          sep.className = 'vp-checkout-separator';
          sep.style.cssText = 'text-align:center;font-family:Inter,sans-serif;font-size:0.68rem;text-transform:uppercase;letter-spacing:0.14em;color:#3D2B1F;opacity:0.35;padding:0.5rem 0 0.6rem;';
          sep.textContent = 'or express checkout';

          payBtn.parentNode.insertBefore(sep, payBtn);
        }
      }, 800);
    } catch (e) {
      // Silent fail
    }
  }

  /* ================================================================
     E. Size Guide Popup
     Hides size guide from gallery, creates modal, injects
     "Size Guide" link next to the Size variant label.
     ================================================================ */

  function initSizeGuidePopup() {
    try {
      // Already injected?
      if (qs('#vp-size-modal')) return;

      // --- 1. Find the size guide image in the gallery ---
      var sizeImg = null;
      var allGalleryImgs = qsa('media-gallery img.product-media__image');

      for (var i = 0; i < allGalleryImgs.length; i++) {
        var img = allGalleryImgs[i];
        var alt = (img.getAttribute('alt') || '').toLowerCase();
        var src = (img.getAttribute('src') || '').toLowerCase();
        if (alt.indexOf('size') !== -1 || src.indexOf('size-guide') !== -1) {
          sizeImg = img;
          break;
        }
      }

      // If no size guide image found, bail — don't inject link
      if (!sizeImg) return;

      // Get full-size URL (use width=1200 for modal display)
      var sizeImgSrc = sizeImg.getAttribute('src') || '';
      // Replace width param for a good modal resolution
      var fullSizeUrl = sizeImgSrc.replace(/&width=\d+/, '&width=1200');
      if (fullSizeUrl.indexOf('width=') === -1) {
        fullSizeUrl += (fullSizeUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=1200';
      }

      // --- 2. Hide size guide from gallery via JS (backup to CSS :has()) ---
      // Hide slideshow slides
      var slideshowSlides = qsa('media-gallery slideshow-slide');
      for (var s = 0; s < slideshowSlides.length; s++) {
        var slideImg = slideshowSlides[s].querySelector('img');
        if (slideImg) {
          var sAlt = (slideImg.getAttribute('alt') || '').toLowerCase();
          var sSrc = (slideImg.getAttribute('src') || '').toLowerCase();
          if (sAlt.indexOf('size') !== -1 || sSrc.indexOf('size-guide') !== -1) {
            slideshowSlides[s].style.display = 'none';
          }
        }
      }

      // Hide grid items (desktop two-column layout)
      var gridItems = qsa('media-gallery .media-gallery__grid > li');
      for (var g = 0; g < gridItems.length; g++) {
        var gImg = gridItems[g].querySelector('img');
        if (gImg) {
          var gAlt = (gImg.getAttribute('alt') || '').toLowerCase();
          var gSrc = (gImg.getAttribute('src') || '').toLowerCase();
          if (gAlt.indexOf('size') !== -1 || gSrc.indexOf('size-guide') !== -1) {
            gridItems[g].style.display = 'none';
          }
        }
      }

      // Hide thumbnail buttons
      var thumbBtns = qsa('button.dialog-thumbnails-list__thumbnail');
      for (var t = 0; t < thumbBtns.length; t++) {
        var tImg = thumbBtns[t].querySelector('img');
        if (tImg) {
          var tAlt = (tImg.getAttribute('alt') || '').toLowerCase();
          var tSrc = (tImg.getAttribute('src') || '').toLowerCase();
          if (tAlt.indexOf('size') !== -1 || tSrc.indexOf('size-guide') !== -1) {
            thumbBtns[t].style.display = 'none';
          }
        }
      }

      // Hide in zoom dialog gallery
      var zoomItems = qsa('.dialog-zoomed-gallery > li');
      for (var z = 0; z < zoomItems.length; z++) {
        var zImg = zoomItems[z].querySelector('img');
        if (zImg) {
          var zAlt = (zImg.getAttribute('alt') || '').toLowerCase();
          var zSrc = (zImg.getAttribute('src') || '').toLowerCase();
          if (zAlt.indexOf('size') !== -1 || zSrc.indexOf('size-guide') !== -1) {
            zoomItems[z].style.display = 'none';
          }
        }
      }

      // --- 3. Create the modal HTML ---
      var overlay = document.createElement('div');
      overlay.className = 'vp-size-modal-overlay';
      overlay.id = 'vp-size-modal';
      overlay.innerHTML =
        '<div class="vp-size-modal">' +
          '<button class="vp-size-modal__close" aria-label="Close">&times;</button>' +
          '<img src="' + fullSizeUrl + '" alt="Size Guide" loading="lazy">' +
          '<a href="/pages/size-guide" class="vp-size-modal__link">View full size guide</a>' +
        '</div>';

      document.body.appendChild(overlay);

      // --- 4. Inject "Size Guide" link next to the Size legend ---
      var sizeFieldset = null;
      var fieldsets = qsa('variant-picker fieldset.variant-option');
      for (var f = 0; f < fieldsets.length; f++) {
        var legend = fieldsets[f].querySelector('legend');
        if (legend && legend.textContent.trim().toLowerCase() === 'size') {
          sizeFieldset = fieldsets[f];
          break;
        }
      }

      if (sizeFieldset) {
        var legend = sizeFieldset.querySelector('legend');
        if (legend) {
          var link = document.createElement('a');
          link.className = 'vp-size-guide-link';
          link.href = '#';
          link.textContent = 'Size Guide';
          legend.appendChild(link);

          // Click handler — open modal
          link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            overlay.classList.add('vp-size-modal-overlay--open');
            document.body.style.overflow = 'hidden';
          });
        }
      }

      // --- 5. Event handlers for closing ---
      function closeModal() {
        overlay.classList.remove('vp-size-modal-overlay--open');
        document.body.style.overflow = '';
      }

      // Close on overlay click (not modal content)
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeModal();
        }
      });

      // Close button
      var closeBtn = qs('.vp-size-modal__close', overlay);
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal();
        });
      }

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('vp-size-modal-overlay--open')) {
          closeModal();
        }
      });

    } catch (e) {
      // Silent fail — size guide popup is non-critical
    }
  }

  /* ================================================================
     Init
     ================================================================ */

  function init() {
    initTrustStrip();
    initMobileStickyATC();
    initATCStateFeedback();
    initCheckoutSeparator();
    initSizeGuidePopup();
  }

  ready(init);
})();
